import React from 'react';
import styled from 'styled-components';
import tr from 'locale';

import PullOutPage from '../../../../blocks/PullOutPage';
import LoaderComponent from 'components/LoaderComponent';
import { Row, Col, SectionHeader, H, Typography, Button } from '@3divi/baseui';
import ActionBlock from '../../../../elements/LicenseInfoList/LicenseActionBlock';
import { themeDefault } from '../../../../themes/themeDefault';
import FileLinkB64 from '../../../../elements/FileLinkB64';
import LicenseInfoList from '../../../../elements/LicenseInfoList';
import LicenseInfoEditable from '../../../../elements/LicenseInfoEditable';

const Content = styled.div`
  padding: 16px 24px 32px;

  @media (max-width: 720px) {
    padding: 16px 16px 32px;
  }
`;

const StyledRow = styled(Row)`
  @media (max-width: 720px) {
    flex-direction: column-reverse;
  }
`;

const Section = styled.div`
  padding: 0 0 16px;
  margin: 0 0 0 -16px;
  box-shadow: none;
`;

const ListWrap = styled.div`
  margin-left: 48px;
  border-bottom: 1px solid ${({ theme }) => theme.border.default};
`;

const ActionWrap = styled.div`
  width: 100%;
`;

const StyledTypography = styled(Typography)`
  padding-bottom: 8px;
`;

function FacePreInfoView({
  header,
  isLoaded,
  activationInfo,
  licenseConfiguration,
  metadata,
  info,
}) {
  return (
    <PullOutPage backUrl={header.backUrl} title={header.title} subtitle={header.subtitle}>
      {!isLoaded && <LoaderComponent />}
      {isLoaded && (
        <Content>
          <H as="h3" padding="8px 0">
            {header.title}
          </H>
          <StyledRow>
            <Col xs={12}>
              {info && (
                <Section>
                  <SectionHeader title={tr('lic_info')} icon="edit" />
                  <ListWrap>
                    {info.map(el =>
                      el.editKey ? (
                        <LicenseInfoEditable
                          key={el.editKey}
                          license={el.license}
                          editKey={el.editKey}
                        />
                      ) : (
                        <LicenseInfoList key={el.text} items={[el]} />
                      )
                    )}
                  </ListWrap>
                </Section>
              )}
              <Section>
                <SectionHeader title={tr('activations_info')} icon="license" />
                <ListWrap>
                  <LicenseInfoList items={activationInfo.items} />
                  <ActionBlock
                    left={activationInfo.action.left}
                    right={
                      <>
                        {activationInfo.action.right.text && (
                          <StyledTypography height="20">
                            {activationInfo.action.right.text}
                          </StyledTypography>
                        )}
                        <ActionWrap>
                          {activationInfo.action.type === 'Button' && (
                            <Button
                              color={themeDefault.themeBlueColor}
                              theme="contained"
                              {...activationInfo.action.right.props}
                            />
                          )}
                          {activationInfo.action.type === 'FileLinkB64' && (
                            <FileLinkB64
                              fileName={'3divi_face_sdk.lic'}
                              license={activationInfo.action.license}
                              {...activationInfo.action.right.props}
                            />
                          )}
                        </ActionWrap>
                      </>
                    }
                  />
                </ListWrap>
              </Section>
              {licenseConfiguration && (
                <Section>
                  <SectionHeader title={tr('license_configuration')} icon="settings" />
                  <ListWrap>
                    <LicenseInfoList items={licenseConfiguration.items} />
                  </ListWrap>
                </Section>
              )}
              {metadata.length > 0 && (
                <Section>
                  <SectionHeader title={tr('metadata')} icon="info" />
                  <ListWrap>
                    <LicenseInfoList items={metadata} />
                  </ListWrap>
                </Section>
              )}
            </Col>
          </StyledRow>
        </Content>
      )}
    </PullOutPage>
  );
}

export default FacePreInfoView;
